"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModePreWidgetConfig = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const upperFirst_1 = __importDefault(require("lodash/upperFirst"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("../../../../utils/helpers");
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const project_config_1 = __importDefault(require("../../../../config/project.config"));
const segmentHelpers = __importStar(require("./helpers"));
const modeIconMapping_1 = require("./modeIconMapping");
const perModePreLabels = {
    walk: (t, interview) => {
        const person = odHelpers.getActivePerson({ interview });
        const personMayHaveDisability = person && odHelpers.personMayHaveDisability({ person: person });
        return personMayHaveDisability
            ? t(['customSurvey:segments:modePre:WalkOrMobilityHelp', 'segments:modePre:WalkOrMobilityHelp'])
            : t(['customSurvey:segments:modePre:Walk', 'segments:modePre:Walk']);
    }
};
const canPersonDriveCar = (interview) => {
    const person = odHelpers.getActivePerson({ interview });
    if (person === null) {
        return true;
    }
    const drivingLicenseOwnership = person && person.drivingLicenseOwnership !== undefined ? person.drivingLicenseOwnership : 'dontKnow';
    if (drivingLicenseOwnership === 'dontKnow' &&
        ((person.age && person.age > project_config_1.default.drivingLicenseAge) || !person.age)) {
        // Check the person's age to not offer the carDriver option if the person is too young
        return true;
    }
    return drivingLicenseOwnership === 'yes';
};
const perModePreConditionals = {
    paratransit: segmentHelpers.conditionalHhMayHaveDisability,
    carDriver: canPersonDriveCar
};
/** TODO Get a segment config in parameter to set the sort order and choices */
const getModePreChoices = (filteredModesPre) => filteredModesPre.map((mode) => ({
    value: mode,
    label: perModePreLabels[mode]
        ? perModePreLabels[mode]
        : (t) => t([`customSurvey:segments:modePre:${(0, upperFirst_1.default)(mode)}`, `segments:modePre:${(0, upperFirst_1.default)(mode)}`]),
    conditional: perModePreConditionals[mode] !== undefined ? perModePreConditionals[mode] : undefined,
    iconPath: (0, modeIconMapping_1.getModePreIcon)(mode)
}));
const getModePreWidgetConfig = (
// FIXME: Type this when there is a few more widgets implemented
options = {}) => {
    // TODO Use a segment configuration to determine which modes should be
    // presented and in which order
    const filteredModes = segmentHelpers.getFilteredModes(options.segmentConfig);
    if (filteredModes.length === 0) {
        throw new Error('No available modes to create modePre widget configuration');
    }
    const filteredModesPre = segmentHelpers.getFilteredModesPre(filteredModes);
    const choices = getModePreChoices(filteredModesPre);
    return {
        type: 'question',
        path: 'modePre',
        inputType: 'radio',
        twoColumns: false,
        datatype: 'string',
        iconSize: '2.25em',
        columns: 2,
        choices,
        label: (t, interview, path) => {
            var _a, _b;
            const person = odHelpers.getPerson({ interview });
            const journey = odHelpers.getActiveJourney({ interview, person });
            const sequence = (0, helpers_1.getResponse)(interview, path, null, '../_sequence');
            const trip = odHelpers.getActiveTrip({ interview, journey });
            const visitedPlaces = journey ? odHelpers.getVisitedPlaces({ journey }) : {};
            // This should never happen, but just in case
            if (!trip || !journey || !person) {
                console.log('Error: trip, journey or person is null in getModePreWidgetConfig, they should all be defined');
                return '';
            }
            const origin = odHelpers.getOrigin({ trip: trip, visitedPlaces });
            const originName = origin
                ? odHelpers.getVisitedPlaceName({ t, visitedPlace: origin, interview })
                : t(['customSurvey:survey:origin', 'survey:origin']);
            const destination = odHelpers.getDestination({ trip: trip, visitedPlaces });
            const destinationName = destination
                ? odHelpers.getVisitedPlaceName({ t, visitedPlace: destination, interview })
                : t(['customSurvey:survey:destination', 'survey:destination']);
            return sequence === 1
                ? t(['customSurvey:segments:ModeFirst', 'segments:ModeFirst'], {
                    context: (_a = options.context) === null || _a === void 0 ? void 0 : _a.call(options),
                    originName,
                    destinationName,
                    count: odHelpers.getCountOrSelfDeclared({ interview, person })
                })
                : t(['customSurvey:segments:ModeThen', 'segments:ModeThen'], {
                    context: (_b = options.context) === null || _b === void 0 ? void 0 : _b.call(options),
                    originName,
                    destinationName,
                    count: odHelpers.getCountOrSelfDeclared({ interview, person })
                });
        },
        validations: function (value) {
            return [
                {
                    validation: (0, LodashExtensions_1._isBlank)(value),
                    errorMessage: (t) => t(['survey:segments:ModeIsRequired', 'segments:ModeIsRequired'])
                }
            ];
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const shouldShowSameAsReverseTrip = segmentHelpers.shouldShowSameAsReverseTripQuestion({
                interview,
                segment
            });
            // Do not show if the question of the same mode as previous trip is shown and the answer is not 'no'
            if (shouldShowSameAsReverseTrip && segment.sameModeAsReverseTrip !== false) {
                if (segment.sameModeAsReverseTrip === true) {
                    // If the question of the same mode as previous trip is shown and the answer is yes, the mode is the same as the previous trip
                    const previousTripSegment = segmentHelpers.getPreviousTripSingleSegment({
                        interview,
                        person: odHelpers.getActivePerson({ interview })
                    });
                    if (previousTripSegment && previousTripSegment.modePre !== undefined) {
                        return [false, previousTripSegment.modePre];
                    }
                }
                // Otherwise, initialize to null
                return [false, null];
            }
            return [true, null];
        }
    };
};
exports.getModePreWidgetConfig = getModePreWidgetConfig;
//# sourceMappingURL=widgetSegmentModePre.js.map